import React from 'react';
import { SocioeconomicDemographicCharts } from './socioeconomicDemographicCharts';
export default React.memo(SocioeconomicDemographicCharts);
